import React from 'react';
import emailjs from "emailjs-com";
import Login from '../Login/Login';
import './AboutMe.css'

export default function AboutMe() {

	function sendEmail(e) {
        e.preventDefault();

    emailjs.sendForm('gmail', 'template_wcwtho8', e.target, 'user_iHdiAL3rNWUnvhytjBFKe')
        .then((result) => {
            console.log(result.text);
        }, (error) => {
            console.log(error.text);
        });
        e.target.reset()
    }
	return (
		<section id="about-area" class="py-70 fix">
						<div class="container">
								<div class="row">
										<div class="col-lg-12 ">
											<div class="about-headline">
												<h3>Why would you like me </h3>
											</div>
										</div>
								</div>
								<div class="row">
										<div class="col-lg-8 pb-5 pb-lg-0 wow animate__animated animate__fadeInLeft animate__fast animate__delay-1s ">
												<div class="about-information">
														<h3>A Piece Of Information...</h3>
														<p class="lead">I'm a Full Stack Web Developer mainly and I have good experience on Graphics Design too. I'm currently performing as a Public Figure & Motivational Speaker on My Youtube Channel. I have been working as a Web Developer around the last 2 years. I used to work on up Work & I have acquired the skills and knowledge necessary to make your project a success. I enjoy every step of the Design process, from discussion and collaboration</p>
														<p class="lead">Moreover I used to work with different Projects as a  Support Admin , I handled inbound calls daily. Recently I am trying to work for the young generation as an Junior Developer</p>
														<div class="cv-button-area d-flex">
																<div class="resume mr-2">
																	<a href="https://www.linkedin.com/in/leo-dewan-nishat-ahmed-252a0a184/" class="btn">Let's Talk</a>
																</div>
																<div class="resume mr-2">
																	<a href="https://www.linkedin.com/in/leo-dewan-nishat-ahmed-252a0a184/" class="btn">Hire Me</a>
																</div>
																<div class="resume mr-2">
																	<a href="#" class="btn">+88-01759380694</a>
																</div>
                                                                 <div>
																	 <Login></Login>
																 </div>
																</div>
												</div>
										</div>
										<div class="d-none d-lg-block col-10 col-md-6 offset-md-3 col-lg-4  offset-lg-0 pt-5 pt-lg-0 wow animate__animated animate__fadeInRight animate__fast animate__delay-1s ">
														<div class="card bg-primary primary-change card-reg-form text-center">
																	<div class="card-body p-4">
																			<h3 class="text-light">Send Message</h3>
																			<p class="text-light">I am answer your all question</p>
																			<form onSubmit={sendEmail}>
																			<div className="row  mx-auto">
                                                                             <div className="col-12 form-group mx-auto">
                                                                              <input type="text" className="form-control" placeholder="Name" name="name"/>
                                                                              </div>
                                                                              <div className="col-12 form-group pt-2 mx-auto">
                                                                              <input type="email" className="form-control" placeholder="Email Address" name="email"/>
                                                                              </div>
                                                                              <div className="col-12 form-group pt-2 mx-auto">
                                                                              <input type="text" className="form-control" placeholder="Subject" name="subject"/>
                                                                              </div>
                                                                              <div className="col-12 form-group pt-2 mx-auto">
                                                                              <textarea className="form-control" id="" cols="30" rows="8" placeholder="Your message" name="message"></textarea>
                                                                               </div>
                                                                              <div className="col-12 pt-3 mx-auto">
                                                                              <input type="submit" className="btn btn-light" value="Send Message"></input>
                                                                               </div>
                                                                                </div>
                                                                          </form>
																	</div>
															</div>
										</div>
								</div>
						</div>
					
				</section>
	);
};

